import Vue from "vue";
class ArquivoServico {
    Get(id) {
        return Vue.prototype.$http({
            url: "arquivo/obter/" + id,
            method: "GET"
        });
    }

    New(arquivos) {
        let formData = new FormData();
        for (let index = 0; index < arquivos.length; index++) {
            formData.append("arquivo", arquivos[index]);
        }
        return Vue.prototype.$http({
            url: "arquivo/new",
            data: formData,
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }
};

export default new ArquivoServico();